<script>
import api from "@/axios";
import Loader from "../components/loader.vue";
import Layout from '../../layouts/main.vue'
import PageHeader from '@/components/page-header.vue'
import appConfig from "@/app.config.json";
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/compras_anim.json'
import { pedidosChart1, pedidosChart2 } from "../components/data-simulados"
import exportFromJSON from "export-from-json"
import DxButton from 'devextreme-vue/button';
// import DxSelectBox from 'devextreme-vue/select-box';
import DxDropDownButton from 'devextreme-vue/drop-down-button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import moment from "moment";
import Swal from "sweetalert2";
import {ref} from "vue";
import useVuelidate from "@vuelidate/core";
import DropZone from "@/components/widgets/dropZone.vue";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Compras",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout, PageHeader, DxButton, DxDropDownButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations,
    Loader,
    DropZone,  Vue3Lottie },

  data() {
    return {
      currentPage: 1,
      totalPages: 0,
      submittedPeriodo: false,
      dtIniFiltro: null,
      dtFimFiltro: null,
      showModalPeriodo: false,
      animationJson,
      title: 'Compras',
      valorTotal: 0,
      items: [
        {
          text: 'Estoque',
          href: '/',
        },
        {
          text: 'Compras',
          active: true,
        },
      ],
      loadingList: true,
      loadingGraph: true,
      pedidoList: null,
      pesqTextFilter: '',

      pedChart1: pedidosChart1,
      pedChart2: pedidosChart2,
      showModalImport: false,
      submittedAnexo: false,
      descranexo: '',

      statusFilterValue: 'T',
      statusFilter: [
        {value: 'T', text: 'Todos os Status'},
        {value: 'CA', text: 'Cancelados'},
        {value: 'CO', text: 'Conferidos'},
        {value: 'FA', text: 'Faturados'},
        {value: 'EL', text: 'Em Elaboração'},
      ],

      dropdownOptions:[
        {value: 'imp', text: 'Importar Excel'},
        {value: 'exp', text: 'Exportar Excel'},
        {value: 'rel', text: 'Relatório Compras no Período'},
      ],
      showModalImportarMovCompra: false,
      showPendenteModalImport: false,
      codProdutoFiltrar: null
    }
  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };

    // return { dropzoneFile, drop};
    return { v$: useVuelidate(), dropzoneFile, drop };
  },

  mounted() {
    console.log('mounted compras-list_0')
    this.atualizaDataList()
  },

  methods: {
    filtrarProduto() {
      Swal.fire({
        position: "center",
        icon: "question",
        input: 'text',
        inputPlaceholder: 'Código de Produto',
        title: "Filtrar Ordens de Serviço",
        text: "Apenas contendo produtos com código:",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          console.log(result)
          console.log(result.value)
          this.codProdutoFiltrar = result.value
          this.atualizaDataList()
        }
      })
    },

    importarCompras() {
      console.log('importar Compra')
      this.showModalImportarMovCompra = true;
    },

    baixarModeloImportacao(){
      api.get(`${getBaseUrl()}api/baixamodelomovmovcompra`, {
        responseType: 'blob'
      }).then(response => {
        console.log('response.data')
        console.log(response.data)

        //Criando link temporário para realizar download
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'econopro_modelo_tabela_importa_compra_v1.xlsx'
        link.click()

        //limpando URL do objeto - limpando memória
        window.URL.revokeObjectURL(link)
      }).catch((error) => {
        console.log('erro ao baixar arquivo')
        console.log(error)
      })
    },

    confirmarImportacaoMovCompra(){
      this.submittedAnexo = true
      if (this.dropzoneFile.name){
        this.showModalAtuLogo = false
        this.updating = true

        let arquivo = document.querySelector(".dropzoneFile").files[0]
        console.log(arquivo)

        let arquivoEmMegas = (arquivo.size / 1000000)

        if(arquivoEmMegas > 2) {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Panilha não pode passar 2 megas!',
            showConfirmButton: false,
            timer: 4000
          }).then(() => {
            this.showModalImportarMovCompra = false
            this.dropzoneFile = ""
          })
        }else{
          let formData = new FormData()
          formData.append("iddata", this.idData)
          formData.append("tipoUpload", this.tipoUpload)
          formData.append("filename", arquivo.name)
          formData.append("file", arquivo)

          this.showModalImportarMovCompra = false
          this.showPendenteModalImport = true

          api.post(`${getBaseUrl()}api/movcompraimpfile2`,formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then((res) => {
            console.log('then axios movcompraimpfile2')
            console.log(res.data)

            if(res.data.success){
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Planilha processada com sucesso!",
                showConfirmButton: false,
                timer: 2000
              }).then(() => {
                this.downloadErrorLog(res.data.erros)

                this.showPendenteModalImport = false
                this.$router.push(`/movcompra/editar/${res.data.movcompra_id}`)
              })
            }else{
              let retorno = res.data

              if(retorno.message){
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: "Processamento falhou!",
                  text: res.data.message,
                  showConfirmButton: false,
                  timer: 5000
                }).then(() => {
                  this.dropzoneFile = ""
                  this.showPendenteModalImport = false
                })
              }else{
                this.downloadErrorLog(res.data.erros)
                console.log('montando texto erros')

                Swal.fire({
                  position: "top-end",
                  icon: "error",
                  title: "Processamento falhou!",
                  showConfirmButton: false,
                  timer: 1500
                }).then(() => {
                  this.showPendenteModalImport = false
                  this.dropzoneFile = ""
                  this.atualizaDataList()
                })
              }
            }
          }).catch((err) => {
            console.log('erro axios')
            // console.log(err)
            // console.log(err.response)
            // console.log(err.response.data.errors)
            let erros = err.response.data.errors
            console.log(erros)
            console.log(typeof  erros)
            let listaErros = []
            Object.keys(erros).forEach(key => {
              console.log(key, erros[key]);
              listaErros.push({
                'titulo': key,
                'mensagem': erros[key]
              })
            });
            this.showPendenteModalImport = false
            this.errosValid = listaErros
            this.updating = false
          })
        }
      }
    },

    downloadErrorLog(errors) {
      if (!errors || errors.length === 0) {
        console.error("Nenhum erro encontrado para salvar.");
        return;
      }

      // Converte o array de erros em um texto formatado
      const errorText = errors.map(err => `Linha ${err.linha}: ${err.erro}`).join("\n");

      // Cria um Blob com o conteúdo do erro
      const blob = new Blob([errorText], { type: "text/plain" });

      // Cria uma URL temporária para o Blob
      const url = URL.createObjectURL(blob);

      // Cria um link para download
      const a = document.createElement("a");
      a.href = url;
      a.download = "erros.txt"; // Nome do arquivo
      document.body.appendChild(a);
      a.click(); // Aciona o clique para baixar
      document.body.removeChild(a); // Remove o link após o download

      // Revoga a URL com um pequeno delay
      setTimeout(() => {
        URL.revokeObjectURL(url);
      }, 1000);
    },

    selectedFile(){
      console.log('selectedFile')
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
      console.log('selectedFile')
    },

    importarExcel(){
      console.log('Abrir modal para importar excel')
      this.showModalImport = true;
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))

      this.showModalPeriodo = false
      this.atualizaDataList()
    },

    relatorio(){
      console.log('relatorio')
      this.loadingList = true

      api.get(`${getBaseUrl()}api/relcompra01`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_compras_001.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingList = false
      })

    },


    getNotas(){
      console.log('getNotas')
      api.get(`${getBaseUrl()}api/getnotas`).then((res) => {
        console.log('then axios')
        console.log(res.data)
      });
    },

    atualizaPagina() {
      window.location.reload();
    },

    confImportar() {
      console.log('confImportar excel')

      let arquivo = document.querySelector(".dropzoneFile").files[0]
      let formData = new FormData()
      formData.append("file", arquivo)
      this.showModalImport = false
      this.loadingList = true

      api.post(`${getBaseUrl()}api/movcompraimpfile`,formData, { // movfileanexo
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res) => {
        console.log('then axios confImportar excel')
        console.log(res)
        this.loadingList = false

        if (!res.data.success) {
          console.log('erro importação do excel...')

          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: res.data.message,
            showConfirmButton: false,
            timer: 2500
          }).then(() => {
            this.descranexo = ''
            this.dropzoneFile = ''
          })
        } else {
          console.log('redirecionando usuário para movcompra...')

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações importadas com sucesso!",
            showConfirmButton: false,
            timer: 2000
          }).then(() => {
            this.descranexo = ''
            this.dropzoneFile = ''

            this.$router.push(`/movcompra/editar/${res.data.id}`)
          })
        }
      }).catch((err) => {
        console.log('erro axios')
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.loadingFiles = false
        }).then(() => {
          this.descranexo = ''
          this.dropzoneFile = ''
        })
    },

    exportExcel(){
      console.log('exportExcel')
      const data = this.pedidoList
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    atualizaDataList(){
      console.log('atualizaDataList')
      //console.log(`statusFilter: ${JSON.stringify(this.statusFilter)}`)

      const filtros = JSON.parse(localStorage.getItem("filtros"))
      //console.log(`filtros: ${JSON.stringify(filtros)}`)

      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro) {
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const di = this.dtIniFiltro
      const df = this.dtFimFiltro
      const q = this.pesqTextFilter
      const s = this.statusFilterValue
      const codProd = this.codProdutoFiltrar

      const paramsReq = {
        'di': di,
        'df': df,
        'q': q,
        's': s,
        'codProd': codProd
      }

      this.loadingList = true
      api.get(`${getBaseUrl()}api/movcompras`, {
        params: paramsReq
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.pedidoList = res.data[0]

        this.pedidoList.forEach((orccompra) => {
          this.valorTotal += orccompra.valorliq
        })

        const dtIniFormated = moment(this.dtIniFiltro)
            .format('DD/MM/YYYY')
        const dtFimFormated = moment(this.dtFimFiltro)
            .format('DD/MM/YYYY')

        this.title = `(${this.pedidoList.length}) Compras: ${dtIniFormated} - ${dtFimFormated}`
        this.loadingList = false
        this.loadingGraph = false
      });
    },

    criarNovo() {
      console.log('criarNovo')
      // this.loadingList = !this.loadingList
    },

    carregouGrid(e){
      console.log('carregouGrid')

      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

      this.title = `(${e.component.totalCount()}) Compras: ${dtIniFormated} - ${dtFimFormated}`
    },

    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key

      window.open(`/movcompra/editar/${idData}`, '_blank')
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          const valStatus = e.data.status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'CA':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'CO':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'FA':
              corStatus = 'rgb(253,179,52)'
              break
            case 'EL':
              corStatus = 'rgb(5,126,236)'
              break

          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;

        }
      }
    },

    onDropClick(e){
      const clickedValue = e.itemData.value;

      switch (clickedValue) {
        case 'imp':
          this.importarExcel();
          break;
        case 'exp':
          this.exportExcel();
          break;
        case 'rel':
          this.relatorio();
          break;
        default:
          console.log('Ação não definida');
      }
    },

    onFilterClick(e){
      const filteredValue = e.itemData.value;
      this.statusFilterValue = filteredValue;

      this.atualizaDataList();
    },

    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);
      this.atualizaPagina()
    },

    nomeStatus(e) {
      switch (e.value) {
        case 'FA':
          return 'Faturado (FA)'
        case 'EL':
          return 'Em Elaboração (EL)'
        case 'CO':
          return 'Conferido (CO)'
        case 'CA':
          return 'Cancelado (CA)'
      }

      return 'Não Definido'
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 4});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss";
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime;
    },

    formatDate(value) {
      // console.log('value formatDate')
      var dateString = value;
      var momentObj = moment(dateString, "YYYY-MM-DD");
      // console.log(momentObj)
      const formatSaida = "DD/MM/YYYY";
      let dateTime = momentObj.format(formatSaida);
      // console.log(dateTime)
      return dateTime;
    }
  },

}
</script>

<template>
  <Layout>

    <span class="float-end" style="z-index: 1000; position: absolute; top: 50px; right: 210px;">
      <Vue3Lottie :animationData="animationJson" :height="200" :width="200"/>
    </span>

    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>

    <div>
      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">

          <DxDropDownButton
              v-model="statusFilterValue"
              :items="statusFilter"
              :drop-down-options="{ width: 150 }"
              icon="filter"
              show-arrow="false"
              hint="Filtrar Status"
              display-expr="text"
              value-expr="value"
              @item-click="onFilterClick"
          />
        </DxItem>

        <!--<DxItem
            location="before"
            widget="dxButton">

          <DxDropDownButton
              :items="dropdownOptions"
              :drop-down-options="{ width: 200 }"
              text="Import/Export de Aquivo"
              display-expr="text"
              value-expr="value"
              icon="file"
              @item-click="onDropClick"
          />
        </DxItem>-->

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="import"
              hint="Importar Compras"
              text="Importar Compras"
              :on-click="importarCompras"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="filter"
              hint="Filtrar Produto"
              :text="codProdutoFiltrar !== null ? codProdutoFiltrar : 'Filtrar Produto'"
              :on-click="filtrarProduto"/>
        </DxItem>

      </DxToolbar>
    </div>

    <Loader v-if="loadingList" style="min-height: 300px;">
    </Loader>

    <div class="mt-2" v-if="!loadingList">
      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="pedidoList"
          :show-borders="true"
          :focused-row-enabled="true"
          :keyExpr="'id'"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true"/>


        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strWmsOsEntradaList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping/>

        <DxColumn
            data-field="id"
            caption="ID"
            sort-order="desc"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="cnpj"
            caption="CNPJ Comprador"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allow-sorting="false"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="codigo"
            caption="Código Compra"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="wmsos_id"
            caption="OS entrada"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="cnf"
            caption="NF-e Associada"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="fornec"
            caption="Fornecedor"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allow-sorting="false"
            :allowHeaderFiltering="true"/>


        <DxColumn
            data-field="cidade"
            caption="Cidade"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allow-sorting="false"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="estado"
            caption="Estado"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allow-sorting="false"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="dtemissao"
            caption="Dt. Emissão"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            :width="110"
            data-field="valorliq"
            caption="Valor"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="status"
            caption="Status"
            alignment="center"
            data-type="text"
            :customize-text="nomeStatus"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="condpgto"
            caption="Cond. Pagamento"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allow-sorting="false"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="created_at"
            caption="Criado em"
            alignment="right"
            data-type="datetime"
            :format="formatDateTime"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>

      </DxDataGrid>
    </div>

    <div class="row" v-if="!loadingGraph">

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Evolução Anual</h4>

            <apexchart
                class="apex-charts"
                height="350"
                type="line"
                dir="ltr"
                :series="pedChart1.series"
                :options="pedChart1.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Fornecedores</h4>

            <apexchart
                class="apex-charts"
                height="320"
                type="pie"
                dir="ltr"
                :series="pedChart2.series"
                :options="pedChart2.chartOptions"
            ></apexchart>

          </div>
        </div>
      </div>


    </div>

    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span>Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span>Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal 
    title="Criar Novo Anexo" 
    v-model="showModalImport" 
    centered 
    hide-footer
    @hide="dropzoneFile = ''">
      <div>
        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFile" />
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedAnexo && !dropzoneFile.name" >
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <label for="descranexo">Descrição</label>
              <div class="position-relative">
                <input
                    id="descranexo"
                    type="text"
                    v-model="descranexo"
                    class="form-control"
                    placeholder="Descrição do anexo"
                    :class="{'is-invalid': submittedAnexo && !descranexo}"/>
                <div v-if="submittedAnexo && !descranexo" class="invalid-feedback">
                  <span>Campo descrição obrigatório, favor preencher.</span>
                </div>

              </div>
            </div>
          </div>
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalImport = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confImportar">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal title="Upload Compra" v-model="showModalImportarMovCompra" hide-footer>
      <div class="row">
        <div class="card-body d-flex justify-content-center">
          <button class="btn btn-info" @click="baixarModeloImportacao">
            <i class="bx bx-download me-1 text-end"></i> Baixar modelo importação
          </button>
        </div>
      </div>

      <div class="row">
        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFile" />
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedAnexo && !dropzoneFile.name" >
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>
      </div>

      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalImportarMovCompra = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarImportacaoMovCompra">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal
        v-model="showPendenteModalImport"
        size="md"
        title-class="font-12"
        title="Só um momento!"
        hide-footer
    >
      <h4>Estamos Processando sua Planilha...</h4>
    </b-modal>

  </Layout>
</template>